export default {
  methods: {
    updateValue(id, value) {
      let item = this.nodes.find(item => item.id === id);
      item.data.value = value;
    },
    filterHierarchy(id) {
      const node = this.nodes.find(item => item.id === id);
      const nodeIndex = this.nodes.findIndex(item => item.id === id);
      const child = this.nodes.find(item => item.parentId === node.id);

      // Remove the node if it has a value of zero
      if (node.data.value === 0) {

        if (child) {
          child.parentId = node.parentId;
        }

        this.nodes.splice(nodeIndex, 1)
      }
      if (child) {
        this.filterHierarchy(child.id);
      }
    }
  }
}
